import React, { useContext, useState } from 'react'
import AddVehicleConfirm from './AddVehicleConfirm'
import DriverAssignmentConfirm from './DriverAssignmentConfirm'
import ValidationModal from 'components/ValidationModal'
import CheckboxConfirm from './CheckboxConfirm'
import RemoveVehicleConfirm from './RemoveVehicleConfirm'
import { QuestionVehiclesKeptOvernight } from './QuestionRow/QuestionVehiclesKeptOvernight'

export const VehicleConfirm_SaveContext = React.createContext();

const VehicleConfirm_Main = ({ requestContext, vehicleContext, reqClass, endorsementType }) => {
  const context = useContext(requestContext);
  const newVehicleContext = useContext(vehicleContext);
  const [confirmChanges, setConfirmChanges] = useState(context[reqClass]?.confirmChanges);
  var vehicleClass = context[reqClass]

  const styles = {
    checkboxContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      paddingRight: '0'
    }
  }

  {/* Ask about where to save value */ }
  const saveConfirmCheckbox = (value) => {
    setConfirmChanges(value);

    var vehicleClassCopy = context[reqClass];
    vehicleClassCopy.confirmation = value;
  }

  return (
    <>
      <div className="row text-dark">
        <div className="col-12">
          {/* Ask about keeping this here and margin bottom */}
          <h5 className='text-primary text-center fw-bold mb-4 text-uppercase'>{endorsementType}</h5>

          {/* Add Vehicle */}
          {endorsementType == "Add Vehicle" &&
            <AddVehicleConfirm policyStateAbbr={context.getStateAbbr(context[reqClass]?.policyState)} vehReqContext={requestContext} vehicleContext={vehicleContext} reqVehicleClass={"addVehicleClass"} />
          }
          {/* Remove Vehicle */}
          {endorsementType == "Remove Vehicle" &&
            <RemoveVehicleConfirm policyStateAbbr={context.getStateAbbr(context[reqClass]?.policyState)} vehReqContext={requestContext} vehicleContext={vehicleContext} reqVehicleClass={"removeVehicleClass"} />
          }
          {/* Replace Vehicle */}
          {endorsementType == "Replace Vehicle" &&
            <>
              <RemoveVehicleConfirm policyStateAbbr={context.getStateAbbr(context[reqClass]?.policyState)} vehReqContext={requestContext} vehicleContext={vehicleContext} reqVehicleClass={"replaceVehicleClass"} />
              <hr />
              <h5 className='text-primary text-center fw-bold mb-4 text-uppercase'>ADD VEHICLE</h5>
              <AddVehicleConfirm policyStateAbbr={context.getStateAbbr(context[reqClass]?.policyState)} vehReqContext={requestContext} vehicleContext={vehicleContext} reqVehicleClass={"replaceVehicleClass"} />
            </>
          }

          {/* Driver Assignment */}
          {vehicleClass?.vehicles?.vehiclesOnPolicy?.storedVehicles?.length > 1 &&
            <DriverAssignmentConfirm vehReqContext={requestContext} reqVehicleClass={reqClass} />
          }

          {/* Display Vehicles Kept Overnight Question (Remove Vehicle ONLY) */}
          {endorsementType == "Remove Vehicle" && vehicleClass?.vehicles?.vehiclesOnPolicy?.storedVehicles?.length > 1 &&
            <>
              <hr />
              <QuestionVehiclesKeptOvernight reqVehicleContext={requestContext} />
              <hr />
            </>
          }

          <VehicleConfirm_SaveContext.Provider
            value={{
              saveConfirmCheckbox,
              confirmChanges
            }}
          >
            <CheckboxConfirm styles={styles} />
          </VehicleConfirm_SaveContext.Provider>
        </div>
      </div>

      <ValidationModal
        title={context.validationTitle}
        show={context.showModal}
        handleClose={() => context.setShowModal(false)}
        validationMsg={context.validationMsg}
      />
    </>
  )
}

export default VehicleConfirm_Main